// extracted by mini-css-extract-plugin
export default {"container":"ingredient-details_container__WcIjY"};